import { HttpContext, HttpContextToken } from "@angular/common/http";

/**
 * Requête de FOND (01/10/2026) : une lecture qui alimente un état GLOBAL (cloche, « Mes tâches »,
 * mode atelier), pas la page affichée. `SpinInterceptor` la laisse passer :
 *  - sans barre de progression — elle clignotait à chaque minute en haut de l'atelier ;
 *  - jamais annulée par une navigation — l'intercepteur coupe toutes les requêtes en cours au
 *    `NavigationStart` : la lecture de « Mes tâches » partie après la connexion était coupée par
 *    l'entrée dans le mode atelier, qui réutilisait cette lecture ratée — atelier VIDE jusqu'à une
 *    minute (vu sur la base Stolpi, d'autant plus probable que le réseau est lent).
 */
export const BACKGROUND_REQUEST = new HttpContextToken<boolean>(() => false);

/** `context` d'une requête de fond (`http.get(url, { context: backgroundRequest() })`). */
export function backgroundRequest(context = new HttpContext()): HttpContext {
  return context.set(BACKGROUND_REQUEST, true);
}
